import React from "react";
import { LoadingIndicator } from "../../";
import { useGlobalValue } from "../../../state/GlobalProvider";
import Icon from "../../Icon/Icon";
import styles from "./FileUploaderStatus.module.sass";
const renderFileList = (files, uploads, removeFile, component) => {
  return files.map((file, index) => {
    const {
      progress,
      error
    } = (uploads.list || []).find(f => f.file === file.name) || {};
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles["file-entry"]
    }, /*#__PURE__*/React.createElement("div", {
      className: "align-center"
    }, progress === undefined && /*#__PURE__*/React.createElement("div", {
      className: `${styles["progress-bar"]} ${styles["progress-bar-files"]}`
    }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("h5", null, file.name), /*#__PURE__*/React.createElement("button", {
      className: styles["remove-button"],
      onClick: e => {
        if (component) {
          e.preventDefault();
          e.stopPropagation();
        }
        removeFile(file);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "remove"
    })))), (progress >= 0 && progress < 1 || typeof progress === "string") && /*#__PURE__*/React.createElement("div", {
      className: `${styles["progress-bar"]} ${styles["progress-bar-loading"]}`
    }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("h5", null, file.name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, typeof progress !== "string" ? `${(progress * 100).toFixed(2)}%` : progress), /*#__PURE__*/React.createElement(LoadingIndicator, {
      className: styles["loading"]
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles["status-wrap"]
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: `${progress * 100}%`
      }
    }))), progress === 1 && /*#__PURE__*/React.createElement("div", {
      className: `${styles["progress-bar"]} ${styles["progress-bar-success"]}`
    }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("h5", null, file.name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, "Success"), /*#__PURE__*/React.createElement(Icon, {
      name: "success",
      className: styles["icon-success"]
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles["status-wrap"]
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: `${progress * 100}%`
      }
    }))), progress === -1 && /*#__PURE__*/React.createElement("div", {
      className: `${styles["progress-bar"]} ${styles["progress-bar-error"]}`
    }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("h5", null, file.name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", {
      className: styles["error-message"]
    }, error), /*#__PURE__*/React.createElement(Icon, {
      name: "remove",
      className: styles["icon-error"]
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles["status-wrap"]
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: `${progress * 100}%`
      }
    })))));
  });
};
const FileUploaderStatus = props => {
  const {
    params,
    uploads,
    uploadFiles
  } = useGlobalValue();
  const {
    files,
    setFiles,
    setRemainingFiles,
    remainingFiles,
    component
  } = props;
  const removeFile = file => {
    uploadFiles && uploadFiles(params.projectId, []);
    setFiles(prevState => {
      const fileList = [...prevState];
      const fileIndex = fileList.findIndex(f => f.name === file.name);
      fileList.splice(fileIndex, 1);
      return fileList;
    });
    setRemainingFiles ? setRemainingFiles(remainingFiles + 1) : null;
  };
  const fileList = renderFileList(files || [], uploads || [], removeFile, component && component === "freshdesk" ? component : undefined);
  if (!uploads.open) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, fileList);
};
export default FileUploaderStatus;